import { type FirebaseOptions } from "firebase/app";

type GoogleMapsConfig = {
  apiKey: string;
};

type InventoryManagerConfig = {
  appUrl: string;
};

type EmbedConfig = {
  /** Serves loader.js, and is the origin of every frame the loader builds. */
  host: string;
};

type IngredifindConfig = {
  googleMaps: GoogleMapsConfig;
  inventoryManager: InventoryManagerConfig;
  embed: EmbedConfig;
  firebase: FirebaseOptions;
};

export const config = {
  googleMaps: {
    apiKey: "AIzaSyB7ULn20EYvboiQHZu6frkCk7fRxnzt-pU",
  },
  inventoryManager: {
    appUrl: "https://inventory.ingredifind.com/",
  },
  embed: {
    host: "embed.igfd.menu",
  },
  firebase: {
    apiKey: "AIzaSyDTLcFKeuTb0TwfOzpHmC1bXn5tnV0Hkxs",
    authDomain: "igfd-mobile.firebaseapp.com",
    projectId: "igfd-mobile",
    storageBucket: "igfd-mobile.appspot.com",
    messagingSenderId: "65313590455",
    appId: "1:65313590455:web:79ac13f1549262c5c4d132",
    measurementId: "G-C25KT8W41L",
  },
} as IngredifindConfig;
